/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useRef} from 'react';
import {Table} from 'antd';
import {
  InstantSearch,
  Configure,
  connectInfiniteHits,
} from 'react-instantsearch-dom';
import {searchClient} from '../../config';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Image',
    render: (props) => {
      return <div />;
    },
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
];

const InfiniteHits = connectInfiniteHits(function ({
  hits,
  hasMore,
  refineNext,
}) {
  const sentinel = useRef(null);

  const onSentinelIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && hasMore) {
        // In that case we can refine
        // refineNext();
      }
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(onSentinelIntersection);

    observer.observe(sentinel.current);

    return () => {
      observer.disconnect();
    };
  }, [sentinel, hits.length]);

  // useEffect(() => {
  //   if (hasMore) {
  //     // In that case we can refine
  //     refineNext();
  //   }
  // }, [hasMore, hits.length]);

  return (
    <div>
      <div style={{height: 50}} ref={sentinel} />
      <Table dataSource={hits} columns={columns} />
    </div>
  );
});

RapidOrder.propTypes = {};

function RapidOrder(props) {
  return (
    <div>
      <InstantSearch indexName="products" searchClient={searchClient}>
        <Configure hitsPerPage={10000} />
        <InfiniteHits />
      </InstantSearch>
    </div>
  );
}

export default RapidOrder;
